<template>
  <div>
    <BlankScreen v-show="showForm" />
    <AppBarLight
      v-show="!showGalleryModal"
      current-section="work"
      :class="`${showForm ? 'hidden' : ''}`"
      @get-in-touch="showForm = true"
    />
    <div class="spacing" />
    <WorkHeader />
    <transition name="fade">
      <ProjectShowcase :grid-items="showcase" />
    </transition>
    <Testimonial
      v-if="showTestimony"
      :key="workKey"
      :data="testimonies"
    />
    <ClientIconsLight
      :key="workKey"
      :data="works"
      :query="queryParams"
      @modal-toggle="galleryModalToggle"
    />
    <ContactUsFooter
      @open-form="handleFormRequest"
    />
    <Footer
      @get-in-touch="openForm"
    />
    <transition name="fade">
      <ContactUsHolder
        v-if="showForm"
        :name="contactInfo.name"
        :email="contactInfo.email"
        :company="contactInfo.company"
        @close-form="closeForm"
      />
    </transition>
    <PrivacyPolicyBanner />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import AppBarLight from '../components/general/AppBarLight.vue';
import BlankScreen from '../components/general/BlankScreen.vue';
import ContactUsFooter from '../components/general/ContactUsFooter.vue';
import ContactUsHolder from '../components/contact_us_form/ContactUsHolder.vue';
import WorkHeader from '../components/works/WorkHeader.vue';
import ProjectShowcase from '../components/project/ProjectShowcase.vue';
import Testimonial from '../components/general/Testimonial.vue';
import ClientIconsLight from '../components/works/ClientIconsLight.vue';
import Footer from '../components/general/Footer.vue';
import PrivacyPolicyBanner from '../components/general/PrivacyPolicyBanner.vue';

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { uuid } from 'vue3-uuid';
gsap.registerPlugin(ScrollToPlugin);

const showForm = ref(false);
const showGalleryModal = ref(false);

const workKey = ref(uuid.v4());

const contactInfo = {
  name:'',
  email:'',
  company:''
};

const handleFormRequest = (payload: any) => {
  contactInfo.name = payload.name;
  contactInfo.email = payload.email;
  contactInfo.company = payload.company;
  showForm.value = true;
};

function galleryModalToggle(value: any){
  showGalleryModal.value = value;
}
const openForm = () => {
  showForm.value = true;
};

const closeForm = () => {
  showForm.value = false;
};

const props = withDefaults(defineProps<{
  wordpressData?: any | null,
}>(), {
  wordpressData: null,
});

const works_items = ref([]);

const works = computed(() => {
  return works_items.value;
});

const showcase = computed(() => {
  let parsedData = [];

  try {
    parsedData = JSON.parse(props.wordpressData.featured_work);
  } catch (error) {
    console.error('Failed to parse featured_work:', error);
  }

  return parsedData;
});

const testimonies = ref({
  testimonies:[]
});

const showTestimony = computed(() => {
  return testimonies.value.testimonies.length > 0;
});

const queryParams = ref('');

onMounted(() => {
  const params = new URLSearchParams(window.location.search);
  const goto = props.wordpressData.query;

  queryParams.value = params.get('filter') || goto;
  works_items.value = props.wordpressData.works;
  works_items.value.forEach((element: any) => {
    element.testimonies.forEach((value: any) => {
      testimonies.value.testimonies.push({testimony:value.testimony});
    });
  });
});

</script>

<style scoped>
.spacing {
  height: 320px;
  width: 100%;
}
.hidden {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 820px) {
  .spacing {
    height: 164px;
  }
}

</style>
